import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Badge"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "badge"
    }}>{`Badge`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { Badge } from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Badge>Badge</Badge>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Heading>
  Components
  <Badge variant="accent">New</Badge>
  <Badge variant="outline" ml={1}>
    Cool
  </Badge>
</Heading>
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Avatar src={images.logo} />
<Badge variant='circle' ml={-3} mt={-3}>16</Badge>
`}</code></pre>
    <h2 {...{
      "id": "variants"
    }}>{`Variants`}</h2>
    <p>{`Badge variants can be defined in `}<inlineCode parentName="p">{`theme.badges`}</inlineCode>{`.
The Badge component uses `}<inlineCode parentName="p">{`theme.badges.primary`}</inlineCode>{` as its default variant.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme variants
{
  badges: {
    primary: {
      color: 'background',
      bg: 'primary',
    },
    outline: {
      color: 'primary',
      bg: 'transparent',
      boxShadow: 'inset 0 0 0 1px',
    },
  },
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      